import * as React from "react"
import IconSkeleton from "./IconSkeleton"
import { IconProps } from "./types"

export default function FastestSpeedIcon(props: IconProps) {
  return (
    <IconSkeleton
      {...props}
      iconName="FastestSpeedIcon"
      applyColorToStroke={false}
    >
      <path
        d="M21.0322 18.1324C20.6937 18.845 19.9751 19.2992 19.1862 19.2992H5.88707C5.09808 19.2992 4.37956 18.845 4.04101 18.1324C3.45958 16.9085 3.13525 15.5403 3.13525 14.1022C3.13525 8.90994 7.34439 4.70081 12.5366 4.70081C16.6101 4.70081 20.0784 7.29145 21.384 10.915L18.7115 10.0999C17.3998 8.08033 15.1242 6.74458 12.5366 6.74458C8.47313 6.74458 5.17903 10.0387 5.17903 14.1022C5.17903 15.2306 5.43306 16.2997 5.88707 17.2554H19.1862C19.5032 16.5879 19.7228 15.8652 19.8264 15.1055L21.9316 14.4521C21.8834 15.7622 21.5663 17.0081 21.0322 18.1324ZM11.4749 13.46C11.3844 13.2413 11.3378 13.0069 11.338 12.7701C11.3378 12.5334 11.3844 12.299 11.4749 12.0803C11.5654 11.8615 11.6982 11.6628 11.8656 11.4954C12.033 11.328 12.2317 11.1952 12.4504 11.1047C12.6692 11.0142 12.9036 10.9677 13.1403 10.9678L22.1521 12.7701L13.1403 14.5725C12.9036 14.5726 12.6692 14.5261 12.4504 14.4356C12.2317 14.3451 12.033 14.2123 11.8656 14.0449C11.6982 13.8775 11.5654 13.6788 11.4749 13.46Z"
        fill="currentColor"
      />
    </IconSkeleton>
  )
}
